import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

import CommonUiIcon from 'webapp/components/common/ui-icon';

interface Args {
	onDeleteAllPermanently: () => void;
}

interface RecentlyDeletedInfoComponentInterface<T> {
	Element: HTMLDivElement;
	Args: T;
}

const RecentlyDeletedInfoComponent: TOC<RecentlyDeletedInfoComponentInterface<Args>> = <template>
	<div class="recently-deleted-info">
		<CommonUiIcon @name="InfoFill" @size="sm" />
		Deleted items are kept for 30 days before being permanently removed.
		<a role="button" {{on "click" @onDeleteAllPermanently}}>Delete all permanently</a>
	</div>
</template>;

export default RecentlyDeletedInfoComponent;
